import { createApiSlice } from "@common";
import { CRUD_BILLING_FREQUENCY } from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "addBillingFrequency",
    method: "post",
    url: CRUD_BILLING_FREQUENCY,
    stateKey: "message",
  },
  {
    name: "getBillingFrequency",
    method: "get",
    url: CRUD_BILLING_FREQUENCY,
    stateKey: "data",
  },
  {
    name: "updateBillingFrequency",
    method: "put",
    url: CRUD_BILLING_FREQUENCY,
    stateKey: "message",
  },
  {
    name: "deleteBillingFrequency",
    method: "delete",
    url: CRUD_BILLING_FREQUENCY,
    stateKey: "message",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "billingFrequency",
  apiConfig,
  customReducers,
);
const billingFrequencySlice = slice;

// Export the slice's reducer
export default billingFrequencySlice.reducer;

// Export thunks
export const {
  addBillingFrequency,
  getBillingFrequency,
  updateBillingFrequency,
  deleteBillingFrequency,
} = thunks;

// Export actions
export const { rowSelect } = actions;
